<template>
  <div class="w-view-shell">
    <!-- 面包屑  -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>首页</el-breadcrumb-item>
      <el-breadcrumb-item>全部课程</el-breadcrumb-item>
      <el-breadcrumb-item class="ke">公需科目</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="video-view-shell">
      <div class="option">
        <div class="year">
          <span>选择年份</span>
          <el-select
            v-model="year"
            placeholder="请选择"
            @change="changeYear"
            class="picker"
          >
            <el-option
              v-for="item in options"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="hint">
        <div>
          <h3>温馨提示</h3>
          <div>1、按省局要求：每节课学习中，请完成<span>随堂考核</span>和<span>提交评价</span>。</div>
          <div>2、公需学分查询：请登录“<span>湖南省药师教育管理平台</span>”-“<span>学分卡</span>”。</div>
          <div>3、每节课不需要一次看完，<span>中途退出，系统自动保留学习记录。</span></div>
        </div>
        <div>
          <img src="@/assets/APPLoad.jpg" alt="">
          <span>手机APP学习</span>
        </div>
      </div>
      <div class="video-arr">
        <div
          class="video-item"
          v-for="(item, index) in video_list"
          :key="index"
        >
          <div>
            <img :src="item.course_img" alt="">
          </div>
          <div>
            <div class="title">
              <h3>{{item.course_name}}</h3>
            </div>
            <span>授课老师：{{item.teacher_name}}</span>
            <span>时长：{{item.file_time | setTime}}分钟</span>
            <div>
              <span>学习进度：{{item.learn_rate}}%</span>
              <el-progress color="#2aa9b5" :percentage="item.learn_rate" :show-text="false" style="width: 200px"></el-progress>
            </div>
          </div>
          <div>
            <!-- <div class="lianxi-btn" @click.stop="go_test(item)">模拟考题</div> -->
            <div class="xuexi-btn" @click.stop="cut_play(item, index)">{{item.learn_status}}</div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog :visible.sync="dialogVisible" width="30%" center>
      <div class="success">
        <h3>专属老师微信</h3>
        <p>快扫码添加你的专属老师微信</p>
        <img src="@/assets/teacher_wx.png" alt="" class="code" />
        <div>服务时间：周一至周五8:30～17；30</div>
      </div>
      <span slot="footer"></span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "Coursetobuy",
  data() {
    return {
      video_list: [],
      user_info: "",
      options: [],
      year: '',
      dialogVisible: false
    };
  },
  filters: {
    setTime (time) {
      return Math.round(time/60)
    }
  },
  created() {
    this.year = this.$route.query.year || ''
    this.getYear()
  },
  mounted() {
    this.changeYear()

    this.$nextTick(() => {
      let openNum = Number(localStorage.getItem('openNum')) || 0
      if (openNum != 2) {
        openNum++
        localStorage.setItem('openNum', openNum)
        this.dialogVisible = true
      }
    })
  },
  destroyed() {
  },
  methods: {
    getYear () {
      this.API.post("user/public_in-public_year", {}).then(res => {
        if (res.errno == 0) {
          this.options = res.data.year
        }
      })
    },
    changeYear () {
      this.API.post("Home/course_out-study_end", {}).then(res => {
        if (res.data.state == 1) {
          this.$confirm('<div style="text-align:left">接省药监局通知,执业药师继续教育<span style="color:red">学习平台和报名通道</span>于2023年7月12日下午18:00起同步<span style="color:red">关闭进行系统升级</span>，预计下周同时开启。</div>', '温馨提示', {
            dangerouslyUseHTMLString: true,
            center: true,
            showCancelButton: false,
            confirmButtonText: '知道了',
          })
        } else {
          this.API.post("user/public_in-buy_status", {year: this.year}).then((res) => {
            if (res.errno == 0) {
              if (res.data.course_status) {
                this.getPublicList()
                this.getUserInfo();
              } else {
                this.$router.push("/PublicBuy?year="+this.year);
              }
            }
          });
        }
      })
    },
    getUserInfo() {
      this.API.post("user/user_infos-user_info", {}).then((res) => {
        this.user_info = res.data.user_info;
        this.$emit("get-info");
      });
    },
    go_test(item) {
      this.$router.push({
        path:
          "/contact?course_id=" +
          item.course_id +
          "&course_type=3" +
          "&directory_id=0" +
          "&=timestamp" +
          new Date().getTime(),
      });
    },
    cut_play(item) {
      if (item.learn_status == '开始学习') {
        let content = '<div style="text-indent: 32px;text-align:left">按省局统一要求，课程学完后请完成“课程评价”，方可通过省局审核！</div>'
        if (this.year == 2026) {
          content += '<div style="text-indent: 32px;text-align:left;"><span style="background-color: yellow;display: inline-block;color: red;text-indent: 0px;">公需学习：8月31日截止！</span></div>'
        }
        this.$confirm(content, '重要提示', {
          dangerouslyUseHTMLString: true,
          confirmButtonText: '知道了',
          closeOnPressEscape: false,
          center: true,
          roundButton: true,
          showCancelButton: false,
          confirmButtonClass: 'alertBtn',
          customClass: 'alertFont',
          callback: action => {
            if (action == 'confirm') {
              this.$router.push({path: '/PublicVideo', query: {course_id: item.course_id, year: this.year}})
            }
          }
        });
        return;
      }
      this.$router.push({path: '/PublicVideo', query: {course_id: item.course_id, year: this.year}})
    },
    getPublicList() {
      // 药师课程列表
      this.API.post("user/public_in-public_course_info", {year: this.year}).then((res) => {
        if (res.errno != 0) {
          return;
        }
        let list = res.data.course_list
        let info = localStorage.getItem("user_info")
        for (let v of list) {
          v.cate_name = JSON.parse(info).leixing
          if (v.is_finish == 1 && v.is_comment == 0) {
            v.learn_status = '继续学习'
            v.learn_rate = 99.99
          }
        }
        this.video_list = list
      });
    },
  },
};
</script>

<style lang="less" scoped>
.video-view-shell {
  margin-bottom: 40px;
}

.el-breadcrumb__item:last-child .el-breadcrumb__inner,
.el-breadcrumb__item:last-child .el-breadcrumb__inner a,
.el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover,
.el-breadcrumb__item:last-child .el-breadcrumb__inner:hover {
  font-weight: 400;
  color: #000;
  cursor: text;
}

.el-breadcrumb {
  height: 47px;
  line-height: 47px;
}

.option {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  .year {
    display: flex;
    align-items: center;
    > span {
      margin-right: 15px;
      font-weight: bold;
      color: #000000;
      font-size: 1.17em;
    }
  }
}
  /deep/ .el-input__inner {
    font-size: 1.4em;
    font-weight: bold;
  }

.hint {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
  align-items: center;
  > div {
    display: flex;
    flex-direction: column;
    h3 {
      font-size: 26px;
      margin-bottom: 10px;
    }
    > div {
      display: flex;
      align-items: center;
      font-size: 20px;
      margin-bottom: 15px;
      span {
        font-size: 20px;
      }
    }
  }
  > div:last-child {
    justify-content: center;
    align-items: center;
    img {
      width: 120px;
      margin-bottom: 15px;
    }
  }
}

.video-arr {
  background-color: #fff;
  padding: 10px 0;
  .video-item {
    display: flex;
    padding: 15px;
    border-bottom: 1px solid #e3e3e3;
    > div:first-child {
      border: 2px solid #2aa9b5;
      width: 200px;
      height: 200px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    > div:nth-child(2) {
      flex: 1;
      margin: 0 20px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .title {
        display: flex;
        align-items: center;
        h3 {
          font-size: 1.2em;
          margin-right: 10px;
        }
      } 
      > span {
        color: #999999;
      }
      > div:last-child {
        display: flex;
        align-items: center;
        span {
          margin-right: 15px;
        }
      }
    }
    > div:last-child {
      display: flex;
      align-items: flex-end;
      > div {
        width: 120px;
        height: 40px;
        line-height: 40px;
        border-radius: 20px;
        text-align: center;
        margin-left: 20px;
        cursor: pointer;
        color: #fff;
        &:hover {
          background-color: #37c9d6;
        }
      }
      .lianxi-btn {
        border: 1px solid #2baab5;
        color: #2baab5;
        background-color: #fff;
        &:hover {
          background-color: #37c9d6;
          color: #fff;
        }
      }
      .xuexi-btn {
        border: 1px solid #2baab5;
        background-color: #2baab5;
      }
    }
  }
}

.success {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  h3 {
    margin: 25px 0;
    font-size: 24px;
  }
  p {
    color: #666666;
    margin-bottom: 25px;
    font-size: 18px;
    text-align: center;
  }
  .code {
    width: 180px;
    margin: 0 0 40px;
  }
}
</style>
